import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { createContext, useContext } from 'react';
const LogParamsContext = createContext(null);
export function LogParamsProvider({ children, params }) {
    const parentParams = useContext(LogParamsContext);
    return (_jsx(LogParamsContext.Provider, { value: Object.assign(Object.assign({}, parentParams), params), children: children }));
}
export function useLogParams() {
    var _a;
    return (_a = useContext(LogParamsContext)) !== null && _a !== void 0 ? _a : {};
}
